import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=04e0663a&scoped=true&"
import script from "./Features.vue?vue&type=script&lang=js&"
export * from "./Features.vue?vue&type=script&lang=js&"
import style0 from "./Features.vue?vue&type=style&index=0&id=04e0663a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e0663a",
  null
  
)

export default component.exports